import { getNetStatus } from './common'

export const connection = {
  /**
   * 获取网络状态
   */
  async getNetStatus(): Promise<TNetStatus> {
    return getNetStatus()
  },
  listenerNet(online, offline) {
    window.addEventListener('online', online)
    window.addEventListener('offline', offline)
  }

} as ConnectionDSL & { listenerNet(online: () => void, offline: () => void): void }

